// // eslint-disable-next-line @typescript-eslint/no-namespace
// export namespace ConfigDefault {
//     export const backgroundColourLM = "25a052" as const;
//     export const backgroundColourLM_Alt = "2473c3" as const;
//     export const backgroundColourDM = "166f20" as const;
//     export const backgroundColourDM_Alt = "0c5985" as const;
//     export const fontSize = 13.0 as const;
// };

 
export const ConfigDefault = {
    backgroundColourLM: "25a052",
    backgroundColourLM_Alt: "2473c3",
    backgroundColourLM_Alt2: "c7d2db",
    backgroundColourDM: "166f20",
    backgroundColourDM_Alt: "0c5985",
    backgroundColourDM_Alt2: "3a4a56",
    fontSize: 14.0,
    fontWeight: 500,
} as const;